import { IUserSubMenu } from '../UserSubMenus';
import { Icon, IconType } from '@repo/ui/components';

export interface ISettingsItemProps {
  item: IUserSubMenu;
  onSelect(): void;
}

export const SettingsItem = (props: ISettingsItemProps) => (
  <div className="flex justify-between px-5 py-3 cursor-pointer" onClick={props.onSelect}>
    <div className="text-base/[175%] font-bold">{props.item.title}</div>
    <div className="flex">
      <button className="flex items-center" onClick={props.onSelect}>
        <Icon icon={IconType.NewNextArrowRight} aria-hidden className="cursor-pointer" width={24} height={24} />
      </button>
    </div>
  </div>
);
